<script>
	import FundingRateInervalOption from '../topInfoSection/FundingRateInervalOption.svelte';
</script>

<div class="flex text-fx-grey-200 text-xs xl:gap-5 gap-2 w-fit items-center">
	<div class="text-fx-grey-300">Interval:</div>
	<FundingRateInervalOption interval="1H" />
	<FundingRateInervalOption interval="24H" />
	<FundingRateInervalOption interval="1Y" />
</div>
